<template lang="pug">
  section
    b-container
      content-loader(:height="7", v-if="alert.busy")
      div(v-else-if="!profileComplete")
        h4 WE NEED SOME MORE INFO FROM YOU
        p Please see your dashboard for outstanding items
        b-button.btn-outline.mr-2(:to="{ name: 'Dashboard'}") GO TO DASHBOARD
      div(v-else="")
        h1.text-right.text-md-left GALLERY
        .row.pt-3
          .col-md-6
            b-button.btn-outline.mb-2(:to="{name: 'Piece'}", :disabled="!quotaReached") ADD PIECE
            //- p(v-if="art.length < 3") UPLOAD AT LEAST THREE PIECES TO YOUR GALLERY
            //- p(v-else="") {{ `YOU HAVE ${artist.submit_quota - art.length} FREE SPACES IN YOUR GALLERY` }}
          .col-md-6.text-right
            b-form-group(label="SHOWING")
              b-form-checkbox-group(:options="statusOptions", v-model="filter.status", switches, @input="getArt(true)", class="d-flex flex-wrap justify-content-left")
        masonry.gallery(v-if="art.length > 0", :cols="{default: 4, 1000: 3, 700: 2, 400: 1}")
          .piece(v-for="piece in art", :key='piece.id')
            router-link(:to="{name: `Piece`, params: { pieceId: piece.id, pieceTitle: kebabMe(piece.title) }}")
              .overlay.d-flex.align-items-center.justify-content-center.text-light
                span.stats(v-if="piece.status === 'available'")
                  span.mx-1
                    font-awesome-icon(icon="eye")
                    span.ml-2 {{ piece.showed }}
                  span.mx-1
                    font-awesome-icon(icon="mouse-pointer")
                    span.ml-2 {{ piece.viewed }}
                  span.mx-1
                    font-awesome-icon(icon="heart")
                    span.ml-2 {{ piece.loved }}
                span.stats(v-else="")
                  span {{ piece.status?piece.status.toUpperCase():'' }}
                .open.text-white
                  font-awesome-icon(icon="plus")
              div
                .placeholder-img.bg-alt(v-if="piece.isDummy || !piece.loaded")
                  b-spinner(type="grow")
                img.thumbnail(v-if="piece.thumbnail_url", :src="getImageUrl(piece.thumbnail_url)", @load="loaded(piece)")
        nothing(v-else="")
</template>

<script>
import standardMix from '@/mixins/standardMix';
import { apiService, userService } from '@/services';
import Vue from 'vue';

export default {
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      art: [],
      artist: {},
      showFilter: true,
      collapsed: true,
      noMore: true,
      statusOptions: ['pending', 'available', 'sold', 'rented'],
      filter: {
        artist_id: 'All',
        status: ['pending', 'available'],
      },
      dummyArt: [
        { id: 'a', isDummy: true },
        { id: 'b', isDummy: true },
        { id: 'c', isDummy: true },
        { id: 'd', isDummy: true },
      ],
      hasAddress: false,
      hasBankAccount: false,
    };
  },
  computed: {
    profileComplete() {
      return (this.hasAddress && this.isVerified);
      // return (this.hasAddress && this.isVerified && this.hasBankAccount);
      // return true;
    },
    quotaReached() {
      if (this.art.length >= this.artist.submit_quote) {
        return false;
      }
      return true;
    },
  },
  methods: {
    async getArt(reset) {
      try {
        if (reset) {
          this.art = [];
          this.filter.offset = 0;
          this.noMore = false;
        }
        this.filter.is_test = this.account.user.is_test;
        this.loading();
        this.addDummies();
        const newArt = await apiService.getArt(this.filter);
        if (newArt.length === 0) {
          this.noMore = true;
        }
        this.removeDummies();
        // eslint-disable-next-line no-restricted-syntax
        for (const item of newArt) {
          this.art.push(item);
        }
        this.clear();
        this.filter.offset += this.filter.limit;
      } catch (error) {
        this.error(error);
        this.noMore = true;
        this.removeDummies();
      }
    },
    loaded(piece) {
      const newPiece = { ...piece };
      newPiece.loaded = true;
      const index = this.art.findIndex(item => item.id === piece.id);
      Vue.set(this.art, index, newPiece);
    },
    addDummies() {
      this.removeDummies();
      this.art.push(...this.dummyArt);
    },
    removeDummies() {
      this.art = this.art.filter(item => !item.isDummy);
    },
  },
  async created() {
    this.busy();
    this.noMore = false;
    this.filter.artist_id = this.profileId;
    this.artist = await userService.getProfile(this.profileId);
    this.hasAddress = this.artist.address_id !== null;
    this.hasBankAccount = this.artist.bank_account_id !== null;
    if (this.profileComplete) {
      await this.getArt();
    }
    this.clear();
  },
  watch: {
    noMore(done) {
      if (done) {
        window.removeEventListener('scroll', this.onScroll);
      } else {
        window.addEventListener('scroll', this.onScroll);
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
};
</script>

<style lang="scss" scoped>
  .gallery {
    .piece {
      margin: 15px;
      position: relative;
      display: block;
      break-inside: avoid-column;
      .thumbnail {
        width: 100%;
      }
      .placeholder-img {
        width: 100%;
        height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .overlay {
        @include cover;
        background-color: rgba(black, 0.5);
        opacity: 1;
        transition: ease-in 0.5s all;
        .stats {
          display: block;
        }
        .open {
          display: none;
        }
        &:hover {
          background-color: transparent;
        .stats {
          display: none;
        }
        .open {
          display: block;
        }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/views/Art.vue